// ProductSection.js
import React from "react";

const ProductSection = ({ title, content }) => {
  return (
    <div className="product-section my-10">
      <h2 className="text-xl font-bold mb-2">{title}</h2>
      <div
        className="text-gray-700 text-base leading-relaxed"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ProductSection;
